enum IStepEnum {
  SELECT_FILES,
  UPLOAD_FILES_PROGRESS,
}

export default IStepEnum;
